import React, { FC } from 'react';
import { stripHtml } from 'app/utils/stripHtml';
import { ToogleLinkButton } from 'app/components/ToogleLinkButton/ToogleLinkButton';
import { BUTTON } from 'app/components/ToogleLinkButton/models.d';
import Typography from 'app/components/Typography';
import { TYPOGRAPHY } from 'app/components/Typography/models.d';
import './RecentInsights.scss';

const RecentInsights: FC<CommonTypes.RecentInsightsProps> = ({
  title,
  description,
  link,
}) => (
  <div className="recent-insights-card">
    <Typography
      variant={TYPOGRAPHY.VARIANT.H5}
      color={TYPOGRAPHY.COLOR.BLACK}
      isBold
      className="recent-insights-card__title"
    >
      {title}
    </Typography>
    <Typography
      variant={TYPOGRAPHY.VARIANT.P}
      color={TYPOGRAPHY.COLOR.BLACK}
      className="recent-insights-card__description"
    >
      {stripHtml(description.slice(0, 250))}...
    </Typography>
    {link && (
      <div className="recent-insights-card__btn">
        <ToogleLinkButton
          version={BUTTON.VERSION.INTERNAL_LINK}
          color={BUTTON.COLOR.BLUE_DARK}
          link={`/insights/${link}`}
        >
          Read More
        </ToogleLinkButton>
      </div>
    )}
  </div>
);
export default RecentInsights;
